import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CookiePolicy = () => {
  return (
    <main data-testid="cookie-page" className="bg-ivory text-navy min-h-screen pt-24">
      <div className="container-editorial py-20 md:py-28 max-w-3xl">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-muteText hover:text-navy mb-12"
        >
          <ArrowLeft size={14} /> Torna alla home
        </Link>

        <p className="overline mb-6">Informativa</p>
        <h1 className="display-2 mb-10">Cookie Policy</h1>

        <p className="lede mb-12">
          Questo sito utilizza cookie tecnici e, previo consenso, cookie di analisi
          per migliorare l'esperienza di navigazione. La presente informativa è
          resa ai sensi del Provvedimento del Garante Privacy del 10 giugno 2021.
        </p>

        <section className="mb-10">
          <h2 className="font-serif text-2xl md:text-3xl mb-3">1. Cosa sono i cookie</h2>
          <p className="text-muteText leading-relaxed">
            I cookie sono piccoli file di testo che i siti visitati inviano al
            terminale dell'utente, dove vengono memorizzati per essere poi
            ritrasmessi agli stessi siti alla visita successiva.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl md:text-3xl mb-3">2. Cookie utilizzati</h2>
          <ul className="space-y-3 text-muteText leading-relaxed list-none">
            <li>
              <strong className="text-navy">Cookie tecnici essenziali</strong> —
              necessari al funzionamento del sito (es. preferenze di navigazione).
              Non richiedono consenso.
            </li>
            <li>
              <strong className="text-navy">Cookie analitici (anonimizzati)</strong> —
              utilizzati per raccogliere statistiche aggregate sull'utilizzo del
              sito. Attivati solo previo consenso.
            </li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl md:text-3xl mb-3">3. Cookie di terze parti</h2>
          <p className="text-muteText leading-relaxed">
            Al momento il sito non utilizza cookie di profilazione di terze parti.
            Eventuali servizi esterni (es. mappe, video) saranno indicati e
            attivati solo previo consenso.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl md:text-3xl mb-3">4. Gestione delle preferenze</h2>
          <p className="text-muteText leading-relaxed">
            L'utente può sempre modificare le proprie preferenze sui cookie tramite
            le impostazioni del browser. Per maggiori informazioni:
            <a
              className="link-underline ml-1"
              href="https://www.garanteprivacy.it/cookie"
              target="_blank"
              rel="noopener noreferrer"
            >
              garanteprivacy.it/cookie
            </a>
            .
          </p>
        </section>

        <p className="text-xs tracking-[0.22em] uppercase text-muteText mt-16">
          Ultimo aggiornamento: dicembre 2025
        </p>
      </div>
    </main>
  );
};

export default CookiePolicy;
